import {
    EXPERIENCES,
    SEARCHED,
    TOTAL
} from "../types";

const initialState = {
    experiences: [],
    searched: false,
    total: 0,
}

export default function clsReducer(
    state = initialState,
    { data, type, payload, bool, code }
) {
    switch (type) {

        case EXPERIENCES: {
            return {
                ...state,
                experiences: data,
            }
        }
        case SEARCHED: {
            return {
                ...state,
                searched: data,
            }
        }
        case TOTAL: {
            return {
                ...state,
                total: data,
            }
        }

        default:
            return state
    }
}